import * as React from "react";
import { forwardRef } from "react";
const SvgDefault = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "m18.758 8.624-8.127 9.08a.99.99 0 0 1-1.41 0L5.294 13.74a1.028 1.028 0 0 1-.004-1.437.99.99 0 0 1 1.415-.005l3.22 3.253 7.451-8.153c.368-.354.898-.641 1.381-.083.323.372.323.809 0 1.31z" }));
const ForwardRef = forwardRef(SvgDefault);
export { ForwardRef as ReactComponent };
